import { Component } from '@angular/core';
import { NavController, ToastController } from 'ionic-angular';
import { AngularFireAuth } from 'angularfire2/auth';

import { LocationListPage } from "../location-list/location-list";
import {Data} from "../../providers/providers";
import {PasswordResetPage} from "../password-reset/password-reset";

@Component({
  selector: 'page-login',
  templateUrl: 'login.html'
})
export class LoginPage {

  account: { email: string, password: string } = {
    email: '', //'test@example.com',
    password: '' // 'test123'
  };

  constructor(public navCtrl: NavController,
              private firebaseAuth: AngularFireAuth,
              public data: Data,
              public toastCtrl: ToastController)
  {}

  doLogin() {

    if (this.firebaseAuth.auth) {
      this.firebaseAuth
        .auth
        .signOut()
        .then(value => {
          this.login();
        });
    }
    else {
      this.login();
    }

  }

  login() {
    console.log('login()');
    // NB: signin will trigger loading of the LocationList page - see WelcomePage.ionViewDidLoad
    this.firebaseAuth
      .auth
      .signInWithEmailAndPassword(this.account.email, this.account.password)
      .catch(err => {
        console.log(err.message);
        let toast = this.toastCtrl.create({
          message: err.message,
          duration: 3000,
          position: 'top'
        });
        toast.present();
      });

  }

  resetPassword() {
    this.navCtrl.push(PasswordResetPage, {});
  }

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts